import { ReactNode } from 'react';

import s from './styles.module.css';

const DataField = ({ title, children }: { title: ReactNode; children: ReactNode }) => (
  <div className={s.line} data-test-id="key-value-list__row">
    <div className={s.key} data-test-id="key-value-list__key">
      {title}
    </div>
    <div className={s.value} data-test-id="key-value-list__value">
      {children}
    </div>
  </div>
);

export { DataField };
